import React from 'react'
import { Stack, Table, TableBody, Grid, TableCell, TableContainer, TableHead, TableRow, Box, Button, TablePagination } from '@mui/material'
import moment from 'moment/moment'
import { useState } from 'react'
//import { Item } from '../../../../common/snippets'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import jsPDF from 'jspdf'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import autoTable from 'jspdf-autotable'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { Item } from '../../../common/snippets'
import {
  SummaryColumn,
  excelHeader,
  lrDetailPdfFooter,
  paymentWiseDrawCellSummary,
  pdfHeaderColumn,
  summarydHeader,
} from '../common/AcountingConstants'
import { focusElemnt, navigation3 } from '../../../common/helper'
import * as id from '../common/AcountingId'

const SummaryTable = ({
  loginData,
  tableData,
  fromDate,
  toDate,
  stateName,
  sourceCity,
  sourceBranch,
  destCity,
  destBranch,
  paymentType,
  gstPaidBy,
  bookingType,
  selReportView,
  status,
  disableExcel,
}) => {
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load } = { ...state }
  const [showTable, setShowTable] = useState(true)
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
  const printClick = (isSave) => {
    setShowTable(false)
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

    const pdfColumns = SummaryColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderColumns = pdfHeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderData = [
      {
        state: stateName,
        sourceCity: sourceCity,
        sourceBranch: sourceBranch,
        destCity: destCity,
        destBranch: destBranch,
        paymentType: paymentType,
        gstPaidBy: gstPaidBy,
        bookingType: bookingType,
      },
    ]
    const bodyData = tableData?.map((item) =>
      item.isTotal || item.isHeading || item.isSubHeading
        ? item
        : {
          srNo: item.SN,
          PaymentTypeName: item.PaymentTypeName,
          Units: item.Units,
          Freight: item.Freight,
          OtherCharges: item.OtherCharges,
          GST: item.GST,
          NetAmount: item.NetAmount,
        }
    )
    const doc = new jsPDF({ orientation: 'p', format: [1240, 1754], unit: 'px', compress: true })
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `GST Report.pdf`,
      subject: 'GST Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: HeaderData,
      columnStyles: {
        0: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        1: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        2: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        3: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        4: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        5: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        6: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        7: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
      },
      theme: 'grid',
      startY: 160,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18).setFont('Roboto', 'bold')
        doc.text(
          `Booking Date: ${moment(fromDate).format('DD-MMM-YYYY')}  To  ${moment(toDate).format('DD-MMM-YYYY')} `,
          data.settings.margin.left,
          150
        )
        doc.text(`Report View: Summary`, doc.internal.pageSize.width - data.settings.margin.left, 150, 'right')
      },
    })
    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0],
      },
      tableLineWidth: 0.6,
      columns: pdfColumns,
      body: bodyData,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2],
      },
      //columnStyles: paymentWiseColumnsStyles,
      //---------------data of table-----------
      columnStyles: {
        0: {
          halign: 'left',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        1: {
          halign: 'left',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        2: {
          halign: 'right',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        3: {
          halign: 'right',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        4: {
          halign: 'right',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        5: {
          halign: 'right',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        6: {
          halign: 'right',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        // 7: {
        //   halign: 'right',
        //   minCellHeight: 36,
        //   fontSize: 16,
        //   cellPadding: 6,
        //   valign: 'middle',
        //   fontStyle: 'normal',
        //   font: 'Roboto',
        //   textColor: [0, 0, 0],
        // },
        // 8: {
        //   halign: 'right',
        //   minCellHeight: 36,
        //   fontSize: 16,
        //   cellPadding: 6,
        //   valign: 'middle',
        //   fontStyle: 'normal',
        //   font: 'Roboto',
        //   textColor: [0, 0, 0],
        // },
        // 9: {
        //   halign: 'right',
        //   minCellHeight: 36,
        //   fontSize: 16,
        //   cellPadding: 6,
        //   valign: 'middle',
        //   fontStyle: 'normal',
        //   font: 'Roboto',
        //   textColor: [0, 0, 0],
        // },
        // 10: {
        //   halign: 'right',
        //   minCellHeight: 36,
        //   fontSize: 16,
        //   cellPadding: 6,
        //   valign: 'middle',
        //   fontStyle: 'normal',
        //   font: 'Roboto',
        //   textColor: [0, 0, 0],
        // },
        // 11: {
        //   halign: 'right',
        //   minCellHeight: 36,
        //   fontSize: 16,
        //   cellPadding: 6,
        //   valign: 'middle',
        //   fontStyle: 'normal',
        //   font: 'Roboto',
        //   textColor: [0, 0, 0],
        // },
        // 12: {
        //   halign: 'right',
        //   minCellHeight: 36,
        //   fontSize: 16,
        //   cellPadding: 6,
        //   valign: 'middle',
        //   fontStyle: 'normal',
        //   font: 'Roboto',
        //   textColor: [0, 0, 0],
        // },
      },
      theme: 'grid',
      didParseCell: (data) => {
        paymentWiseDrawCellSummary(data)
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System | GST Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont('Roboto', 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        lrDetailPdfFooter(data, loginData, totalPagesExp)
      },
      showHead: 'never',
    })
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`GST Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('ownBooingDetailed').data = pdfUrl
        // document.getElementById('ownBooingDetailed').data = doc.output('datauristring', ' GST Report.pdf')
        focusElemnt('backBtn')
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('ownBooingDetailed').data = pdfUrl
        // document.getElementById('ownBooingDetailed').data = doc.output('datauristring', ' GST Report.pdf')
        focusElemnt('backBtn')
      }, 2000)
    }
  }
  const SecontInsideRowContent = ({ item, index }) => {
    return (
      <>
        <TableRow style={{ verticalAlign: 'top' }}>
          {item.isTotal ? (
            <>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              ></TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'left' }}
              >
                {item.PaymentTypeName}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.Units}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.Freight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right', whiteSpace: 'nowrap' }}
              >
                {item.OtherCharges}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.GST}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.NetAmount}
              </TableCell>
            </>
          ) : item.isHeading ? (
            <>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#bfe1ff', fontSize: '12px', fontWeight: '700', textAlign: 'left' }}
              >
                {item.srNo}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#bfe1ff', fontSize: '12px', fontWeight: '700', textAlign: 'left' }}
              >
                {item.PaymentType}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#bfe1ff', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.Units}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#bfe1ff', fontSize: '12px', fontWeight: '700', textAlign: 'right', whiteSpace: 'nowrap' }}
              >
                {item.Freight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#bfe1ff', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.OtherCharges}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#bfe1ff', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.GST}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#bfe1ff', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.NetAmount}
              </TableCell>
            </>
          ) : item.isSubHeading ? (
            <>
              <TableCell
                className="reportTD"
                colSpan={3}
                style={{ background: '#e5f3ff', fontSize: '12px', fontWeight: '700', textAlign: 'left' }}
              >
                {item.srNo}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={4}
                style={{ background: '#e5f3ff', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.PaymentTypeName}
              </TableCell>
            </>
          ) : (
            <>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'bfe1ff', fontSize: '12px', fontWeight: '500', textAlign: 'left' }}
              >
                {item.SN}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'bfe1ff', fontSize: '12px', fontWeight: '500', textAlign: 'left' }}
              >
                {item.PaymentTypeName}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'bfe1ff', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
              >
                {item.Units}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'bfe1ff', fontSize: '12px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
              >
                {item.Freight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'bfe1ff', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
              >
                {item.OtherCharges}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'bfe1ff', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
              >
                {item.GST}
              </TableCell>

              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'bfe1ff', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.NetAmount}
              </TableCell>
            </>
          )}
        </TableRow>
      </>
    )
  }
  const SecontInsideRowContentForExcel = ({ item, index }) => {
    return (
      <>
        <TableRow style={{ verticalAlign: 'top', fontSize: '16px' }}>
          {item.isTotal ? (
            <>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}
              ></TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'left' }}>
                {item.PaymentTypeName}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                {item.Units}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                {item.Freight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right', whiteSpace: 'nowrap' }}
              >
                {item.OtherCharges}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                {item.GST}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                {item.NetAmount}
              </TableCell>
            </>
          ) : item.isHeading ? (
            <>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#bfe1ff', fontWeight: '500', textAlign: 'left' }}>
                {item.srNo}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#bfe1ff', fontWeight: '500', textAlign: 'left' }}>
                {item.PaymentType}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#bfe1ff', fontWeight: '500', textAlign: 'right' }}>
                {item.Units}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#bfe1ff', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
              >
                {item.Freight}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#bfe1ff', fontWeight: '500', textAlign: 'right' }}>
                {item.OtherCharges}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#bfe1ff', fontWeight: '500', textAlign: 'right' }}>
                {item.GST}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#bfe1ff', fontWeight: '500', textAlign: 'right' }}>
                {item.NetAmount}
              </TableCell>
            </>
          ) : item.isSubHeading ? (
            <>
              <TableCell className="reportTD" colSpan={3} style={{ background: '#e5f3ff', fontWeight: '500', textAlign: 'left' }}>
                {item.srNo}
              </TableCell>
              <TableCell className="reportTD" colSpan={4} style={{ background: '#e5f3ff', fontWeight: '500', textAlign: 'right' }}>
                {item.PaymentTypeName}
              </TableCell>
            </>
          ) : (
            <>
              <TableCell className="reportTD" colSpan={1} style={{ background: 'bfe1ff', fontWeight: '500', textAlign: 'left' }}>
                {item.SN}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: 'bfe1ff', fontWeight: '500', textAlign: 'left' }}>
                {item.PaymentTypeName}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: 'bfe1ff', fontWeight: '500', textAlign: 'right' }}>
                {item.Units}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'bfe1ff', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
              >
                {item.Freight}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: 'bfe1ff', fontWeight: '500', textAlign: 'right' }}>
                {item.OtherCharges}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: 'bfe1ff', fontWeight: '500', textAlign: 'right' }}>
                {item.GST}
              </TableCell>

              <TableCell className="reportTD" colSpan={1} style={{ background: 'bfe1ff', fontWeight: '500', textAlign: 'right' }}>
                {item.NetAmount}
              </TableCell>
            </>
          )}
        </TableRow>
      </>
    )
  }
  return (
    <>
      <Stack style={{ margin: '0px 10px' }}>
        <Item className="userReport" style={{ paddingRight: '0px', paddingBottom: '0px' }}>
          <Item className="userReport-heading">Report For: GST Report</Item>
          <Item className="userReport-buttons">
            {showTable ? (
              <>
                {disableExcel ? (
                  <Box>
                    <Button variant="outlined" className="userWisereporttembtn" disabled={true}>
                      Export to Excel
                    </Button>
                  </Box>
                ) : (
                  <Box onKeyDown={(e) => navigation3(e, 'gstExportAsPdfBtn', id.gstSplitButton, () => { })}>
                    <ReactHtmlTableToExcel
                      id="gstExportToExlbtn"
                      // id="test-table-xls-button"
                      className="userWisereporttemExcelBtn"
                      table="table-to-xls1"
                      filename={`GST Report ${currentDateTime}`}
                      sheet="tablexls"
                      buttonText="Export to Excel"
                    />
                  </Box>
                )}
                <Box>
                  <Button
                    variant="outlined"
                    onKeyDown={(e) =>
                      navigation3(e, 'gstPrintBtn', 'gstExportToExlbtn', () => {
                        printClick(true)
                      })
                    }
                    id="gstExportAsPdfBtn"
                    className="userWisereporttembtn"
                    onClick={() => printClick(true)}
                  >
                    Export to Pdf
                  </Button>
                </Box>
                <Box>
                  <Button
                    variant="outlined"
                    onKeyDown={(e) =>
                      navigation3(e, id.gstFromDate, 'gstExportAsPdfBtn', () => {
                        printClick(false)
                      })
                    }
                    id="gstPrintBtn"
                    className="userWisereporttembtn"
                    onClick={() => printClick(false)}
                  >
                    Print
                  </Button>
                </Box>
              </>
            ) : (
              <>
                <Box>
                  <Button id="backBtn" variant="outlined" className="userWisereporttembtn" onClick={() => setShowTable(true)}>
                    Back
                  </Button>
                </Box>
              </>
            )}
          </Item>
        </Item>
      </Stack>
      {showTable ? (
        <>
          <Stack sx={{ marginLeft: 2, marginRight: 2, height: 430, paddingTop: '7px', marginBottom: '16px' }} className="changeScrollColor">
            <TableContainer style={{ borderRadius: '6px', border: '1px solid rgb(224 224 224)' }}>
              <Table id="table-to-xls1" className="table1 table-Report" size="small" aria-label="a dense table" style={{ display: 'none' }}>
                <TableHead>
                  <TableRow>
                    <TableCell className="reportTD" style={{ fontSize: '18px', fontWeight: 'bold', textAlign: 'left' }} colSpan={5}>
                      Report For: GST Report
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '18px', fontWeight: 'bold', textAlign: 'left' }} colSpan={5}>
                      Company Name : _Maven Tech Services Pvt. Ltd.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={10}></TableCell>
                  </TableRow>
                  <TableRow style={{ color: 'white' }}>
                    {excelHeader?.map((item, i) => (
                      <TableCell
                        className="ReportItemHead"
                        style={{ backgroundColor: '#e5f3ff', color: '#454646', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={item.col}
                        key={i}
                      >
                        {item.value}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{moment(fromDate).format('DD/MM/YYYY')}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{moment(toDate).format('DD/MM/YYYY')}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{stateName}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{sourceCity}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{sourceBranch}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{destCity}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{destBranch}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{paymentType}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{gstPaidBy}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{bookingType}</span>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={10}></TableCell>
                  </TableRow>
                </TableHead>
                <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}></TableHead>
                {tableData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={13}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '12px',
                              lineheight: '16px',
                              letterspacing: '0.24px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : tableData?.length >= 1 ? (
                  <TableBody
                    className="filter-data-row"
                    style={{
                      textAlign: 'center',
                      fontSize: '12px',
                      lineheight: '16px',
                      letterspacing: '0.24px',
                      fontWeight: '500',
                      marginLeft: '5px',
                    }}
                  >
                    {tableData?.map((item, index) => (
                      <SecontInsideRowContentForExcel item={item} index={index} key={index} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
              <Table id="table-to-xls" className="table1 table-Report" size="small" aria-label="a dense table">
                <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
                  {/* <TableRow>
                    {summarydHeader?.map((i, index) => (
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#444',
                          fontSize: '12px',
                          lineheight: '16px',
                          letterspacing: '0.24px',
                          fontWeight: '500',
                          //  textAlign: `${i.align}`,
                        }}
                        colSpan={1}
                      >
                        {i}
                      </TableCell>
                    ))}
                  </TableRow> */}
                </TableHead>
                {tableData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={13}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '12px',
                              lineheight: '16px',
                              letterspacing: '0.24px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : tableData?.length >= 1 ? (
                  <TableBody
                    className="filter-data-row"
                    style={{
                      textAlign: 'center',
                      fontSize: '12px',
                      lineheight: '16px',
                      letterspacing: '0.24px',
                      fontWeight: '500',
                      marginLeft: '5px',
                    }}
                  >
                    {tableData?.map((item, index) => (
                      <SecontInsideRowContent item={item} index={index} key={index} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
            </TableContainer>
          </Stack>
        </>
      ) : (
        <>
          {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          {load ? (
            <object
              id="ownBooingDetailed"
              type="application/pdf"
              width={'100%'}
              height="440"
              title="MTLPL -Cargo System - After Transfer Summary Report"
              aria-label="MTLPL -Cargo System - After Transfer Summary Report"
            ></object>
          ) : (
            ''
          )}
        </>
      )}
    </>
  )
}
export default SummaryTable
